/**
 * Onglets en tête de page (menus simplifiés, module `navigation_v3`, ADR 0069).
 *
 * Une entrée de menu qui regroupe des pages voisines (Patients et Familles,
 * Utilisateurs et Rôles…) les affiche ici en onglets. Chaque onglet est une
 * page existante, avec son adresse et ses droits : un onglet sans droit ou
 * sans module n'apparaît pas. Rien sans le module, ni sur les fiches de détail.
 */
import { Link, useLocation } from "react-router-dom";

import { navPageTabs } from "@/config/navigation";
import { useAuthStore } from "@/features/auth/store";
import { cn } from "@/lib/utils";

export function NavPageTabs() {
  const me = useAuthStore((s) => s.me);
  const { pathname, search } = useLocation();
  const page = navPageTabs(me, pathname, search);
  if (!page) return null;

  return (
    <nav
      aria-label="Pages de la rubrique"
      className="border-b border-border px-4 pt-3 lg:px-6"
    >
      <ul className="-mb-px flex gap-1 overflow-x-auto">
        {page.tabs.map((tab) => {
          const active = tab.href === page.active;
          return (
            <li key={tab.href} className="shrink-0">
              <Link
                to={tab.href}
                aria-current={active ? "page" : undefined}
                className={cn(
                  "inline-flex min-h-10 items-center whitespace-nowrap border-b-2 px-3 text-sm font-medium transition-colors",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary",
                  active
                    ? "border-primary-text font-semibold text-primary-text"
                    : "border-transparent text-muted-foreground hover:text-foreground",
                )}
              >
                {tab.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
